//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CFooter from "@/common/Footer"
export default{
  data(){
    return{

    }
  },
  components: {
    CFooter
  },
}



// WEBPACK FOOTER //
// ./src/components/product/beian.vue